/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import TablePagination from "@material-ui/core/TablePagination";
import {
  getFilterPermissions,
  getFilterPermissionsHr,
  getFilterPermissionApprover,
} from "../../actions/permissions-actions";
import { saveVacant } from "../../actions/vacant-actions";
import DetailedAccordion from "./permissionSearchAccordion";
import PermissionSearchForm from "./permissionSearchForm";
import Search from "../../images/icons/search.svg";
import { useStateValue } from "../../context/store";
import { headers } from "./models";
import ModalConfirmBaseComment from "../../utils/form/modalConfirmBaseComment";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import { Backdrop, CircularProgress, Typography } from "@material-ui/core";
import {
  ERROR_MESSAGE,
  REQUISITIONCANCEL,
  REQUISITIONREJECT,
  REQUISITIONCLOSE,
  REQUISITIONAPPROVE,
  NORMALUSER,
  APPROVER,
  RHMANAGE,
} from "../../constants";
import Utils from "../../utils/utils";
import { permissionsConstans } from "../../constansPermissions";
import {
  getContractTypeForGenerate,
  getMaestras,
} from "../../actions/generation-contarct-action";

//BUSCAR PERMISOS

const PermissionSearch = (props) => {
  const { type } = props.match.params;
  const [{ filterPermissionsForm, breadCrumb }, dispatch] = useStateValue();
  const [isLoading, setIsLoading] = useState(false);
  const [permissionsRequisition, setPermissionsRequisition] = useState([]);
  const [contractTypes, setContractTypes] = useState([]);
  const [maestras, setMaestras] = useState([]);
  const [message, setMessage] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    oneButtons: false,
    type: "",
  });

  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    type: "",
    isCommentRequired: false,
  });

  const [filter, setFilter] = useState({
    initDate: null,
    endDate: null,
    firstName: null,
    lastName: null,
    regional: null,
    status: null,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "requestDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  useEffect(() => {
    const getDataMaestras = async () => {
      const resp = await getMaestras();
      setMaestras(resp?.data?.maestras);
    };
    getDataMaestras();
  }, []);

  const [toggleSearch, setToggleSearch] = useState(false);

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Consultar permisos",
      breadCrumbSubText: "Consultar permisos",
      index: 21,
    });
  }, []);

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const { path } = useRouteMatch();

  useEffect(() => {
    const getContracTypeList = async () => {
      const contracTypeList = await getContractTypeForGenerate();
      setContractTypes(contracTypeList.data);
    };
    getContracTypeList();
  }, []);

  const getPermissions = async () => {
    var d = new Date();
    d.setHours(0, 0, 0, 0);

    var initDate = filter.initDate
      ? Utils.getFormattedDateyyyyMMdd(filter.initDate, "-")
      : null;

    const dataLocalStorage = JSON.parse(localStorage.getItem("state"));
    const rolRRHH = dataLocalStorage?.userInfo?.roleList.filter(
      (x) => x?.name === "DIRECTOR DE RECURSOS HUMANOS"
    );

    const filterData = {
      initPermissionDate: initDate,
      endPermissionDate: filter.endDate
        ? filter.endDate.toISOString().split("T")[0]
        : d.toISOString().split("T")[0],
      regionalId: filter.regional === "" ? null : filter.regional,
      status: filter.status === "" ? null : filter.status,
      employeeName: filter.firstName === "" ? null : filter.firstName,
      employeeSurname: filter.lastName === "" ? null : filter.lastName,
    };
    const paginatorFilter = {
      page: paginadorRequest.page,
      size: paginadorRequest.size,
      order: paginadorRequest.order,
      columnOrder: paginadorRequest.columnOrder,
    };

    let response = {};
    if (type === RHMANAGE) {
      response = await getFilterPermissionsHr(
        filterData,
        paginatorFilter,
        dispatch
      );
    } else if (type === NORMALUSER) {
      const normalUserFilter = {
        initPermissionDate: initDate,
        endPermissionDate: filter.endDate
          ? filter.endDate.toISOString().split("T")[0]
          : d.toISOString().split("T")[0],
        status: filter.status === "" ? null : filter.status,
        regionalId: null,
        employeeName: null,
        employeeSurname: null,
      };
      response = await getFilterPermissions(
        normalUserFilter,
        paginatorFilter,
        dispatch
      );
    } else if (type === APPROVER) {
      response = await getFilterPermissionApprover(
        filterData,
        paginatorFilter,
        dispatch
      );
    }

    if (
      (response.status === 200 || response?.status === 201) &&
      response.data
    ) {
      const data = response.data.permissionPage;
      if (data.content?.length > 0) {
        setPaginadorResponse({
          data: data.content,
          totalRows: data.totalElements,
          pageSize: data.size,
          pageNumber: data.number,
        });
      } else {
        emptyPaginator();
      }
    } else if (response?.status > 399) {
      setMessage({
        open: true,
        question: response.data.detail ? response?.data.detail : ERROR_MESSAGE,
        type: "WARNING",
        oneButtons: true,
        handleClick: closeMessage,
      });
      emptyPaginator();
    } else {
      emptyPaginator();
    }
  };

  const emptyPaginator = () => {
    setPaginadorResponse({
      data: [],
      totalRows: 0,
      pageSize: 0,
      pageNumber: 0,
    });
  };

  if (breadCrumb?.handleCreatePermission) {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Permisos",
      breadCrumbSubText: "Tramitar permiso de empleado",
      index: 19,
      handleCreatePermission: false,
    });
    setTimeout(() => {
      props.history.push(`/dashboard/permissions`);
    }, 100);
  }

  useEffect(() => {
    setToggleSearch(!toggleSearch);
    let text = "Consultar permisos";
    let index = 21;
    if (type === RHMANAGE) {
      text = "Gestionar permisos";
      index = 21;
    }
    if (type === NORMALUSER) {
      text = "Mis permisos";
      index = 27;
    }
    if (type === APPROVER) {
      text = "Tramitar permisos";
      index = 28;
    }
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: text,
      breadCrumbSubText: text,
      index: index,
    });
  }, [dispatch]);

  if (
    filterPermissionsForm &&
    filterPermissionsForm?.isFilter &&
    filter !== filterPermissionsForm.filter
  ) {
    var newfilter = filterPermissionsForm.filter;
    filter.firstName = newfilter.firstName;
    filter.lastName = newfilter.lastName;
    filter.regional = newfilter.regional;
    filter.initDate = newfilter.initDate;
    filter.endDate = newfilter.endDate;
    filter.status = newfilter.status;
    paginadorRequest.page = 0;
    getPermissions();
    dispatch({
      type: "SET_FILTER_PERMISSIONS_FORM",
      isFilter: false,
    });
  }

  useEffect(() => {
    getPermissions();
  }, [paginadorRequest]);

  const verRequisicion = (id) => {
    props.history.push(`${path}/detalle/${id}`);
  };

  const editarRequisicion = (id) => {
    props.history.push(`${path}/edit/${id}`);
  };

  const closeMessage = () => {
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const actualizarEstadoRequisicion = async (id, comments, status, url) => {
    setIsLoading(true);
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
      isCommentRequired: false,
    }));
    var cancelData = {
      id: id,
      user: "Developer",
      status: status,
      observation: comments,
    };
    const response = ""; //await updateRequisitionStatus(cancelData, dispatch, url);
    if (
      response &&
      (response.status === 200 ||
        response.status === 201 ||
        response.status === 202)
    ) {
      setIsLoading(false);
      setMessage({
        open: true,
        question: "Requisición actualizada correctamente",
        type: "SUCCESS",
        oneButtons: true,
        // handleClickOut: closeMessage,
        handleClick: closeMessage,
      });
      getPermissions();
    } else {
      setIsLoading(false);
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: response?.data?.detail
            ? response?.data?.detail
            : ERROR_MESSAGE,
        },
      });
    }
  };

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
      isCommentRequired: false,
    }));
  };

  // *** Manejo de estados ***
  // Anulada
  // Aprobada
  // Publicada
  // Cerrada
  // Reachazada

  const anularRequisicionConfirm = (id) => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que desea anular el registro?",
      handleClick: (comm) =>
        actualizarEstadoRequisicion(id, comm, "ANULADO", REQUISITIONCANCEL),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      isCommentRequired: false,
    }));
  };

  const aprobarRequisicionConfirm = (id) => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que desea aprobar el registro?",
      handleClick: (comm) =>
        actualizarEstadoRequisicion(id, comm, "APROBADO", REQUISITIONAPPROVE),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      isCommentRequired: false,
    }));
  };

  const crearVacante = async (vacant) => {
    setIsLoading(true);
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));

    const response = await saveVacant(vacant, dispatch);
    if (
      response &&
      (response.status === 200 ||
        response.status === 201 ||
        response.status === 202)
    ) {
      setIsLoading(false);
      setMessage({
        open: true,
        question: "Vacante publicada exitosamente",
        type: "SUCCESS",
        oneButtons: true,
        handleClick: closeMessage,
      });
      getPermissions();
    } else {
      setIsLoading(false);
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: response?.data?.detail
            ? response?.data?.detail
            : ERROR_MESSAGE,
        },
      });
    }
  };

  const publicarRequisicionConfirm = (data) => {
    let body = {
      requisition: data.id,
      salary: data.salario ? data.salario.replace(/\./g, "") : data.salario,
      salaryAgreed: data.salarioConvenir,
      observation: "",
      callType: data.tipoConvocatoria,
    };
    setMessage(() => ({
      open: true,
      title: "Publicar Vacante",
      question: "¿Está seguro que desea publicar esta vacante?",
      handleClick: () => crearVacante(body),
      handleClickOut: closeMessage,
      buttonOneText: "ACEPTAR",
      type: "QUESTION",
    }));
  };

  const cerrarRequisicionConfirm = (id) => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que desea cerrar el registro?",
      handleClick: (comm) =>
        actualizarEstadoRequisicion(id, comm, "CERRADA", REQUISITIONCLOSE),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      isCommentRequired: true,
    }));
  };
  const rechazarRequisicionConfirm = (id) => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que desea rechazar el registro?",
      handleClick: (comm) =>
        actualizarEstadoRequisicion(id, comm, "RECHAZADO", REQUISITIONREJECT),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      isCommentRequired: false,
    }));
  };

  const validationPermissionSearch = () => {
    const origin = type === APPROVER ? "tramit" : "manage";
    return (
      <PermissionSearchForm
        origin={origin}
        type={type}
        toggleSearch={toggleSearch}
      />
    );
  };

  return (
    <div style={{ marginTop: "25px" }}>
      <ModalConfirmBase
        open={message.open}
        description={message.question}
        handleClickOut={message.handleClickOut}
        handleClick={message.handleClick}
        oneButtons={message.oneButtons}
        textButtonSubmit={message.buttonOneText}
        type={message.type}
      />
      <ModalConfirmBaseComment
        open={confirm.open}
        description={confirm.question}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
        textButtonSubmit={confirm.buttonOneText}
        type="QUESTION"
        isCommentRequired={confirm.isCommentRequired}
      />

      {validationPermissionSearch()}
      {paginadorResponse.data.map((row, index) => (
        <DetailedAccordion
          headers={headers}
          data={row}
          onView={verRequisicion}
          onEdit={editarRequisicion}
          onDelete={anularRequisicionConfirm}
          onApprove={aprobarRequisicionConfirm}
          onPublish={publicarRequisicionConfirm}
          onClose={cerrarRequisicionConfirm}
          onReject={rechazarRequisicionConfirm}
          showEdit={row.status === "En_elaboracion"}
          showDelete={row.status === "En_elaboracion"}
          contractTypes={contractTypes}
          permissionsRequisition={permissionsRequisition}
          permissionsConstans={permissionsConstans}
          getPermissions={getPermissions}
          type={type}
          maestras={maestras}
        />
      ))}
      {paginadorResponse.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
          labelRowsPerPage="Registros por página"
        />
      ) : (
        <div>
          <div
            style={{
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "10%",
              display: "flex",
            }}
          >
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado.
            </Typography>
          </div>
        </div>
      )}
      <Backdrop style={{ zIndex: "9999" }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default withRouter(PermissionSearch);
